if (!customElements.get('card-product')) {
  class CardProduct extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        swatches: '[data-swatch]',
        media: '[data-card-media]',
        image: '[data-card-image]',
        cardLink: '[data-card-link]',
      };

      this.variants = JSON.parse(
        this.querySelector('[type="application/json"][data-variants]')
          .textContent,
      );

      this.variantsImages = JSON.parse(
        this.querySelector('[type="application/json"][data-variants-images]')
          .textContent,
      );
    }

    connectedCallback() {
      this.swatches = this.querySelectorAll(this.selectors.swatches);
      this.media = this.querySelector(this.selectors.media);
      this.image = this.querySelector(this.selectors.image);
      this.cardLink = this.querySelector(this.selectors.cardLink);

      this.swatches.forEach((swatch) => {
        swatch.addEventListener('change', this.onSwatchChange.bind(this));
      });
    }

    onSwatchChange(e) {
      const filtered = this.variants.filter((variant) => {
        return variant.options.includes(e.target.dataset.valueOriginal);
      });

      const url = new URL(this.cardLink.href);
      const params = new URLSearchParams(url.search);

      params.set('variant', filtered[0].id);
      this.cardLink.search = params;

      const newImage = this.getImage(filtered[0].id);

      // New image is the same as the current image
      if (this.image.src.split('//')[1] === newImage.src.split('//')[1]) return;

      this.media.classList.add('is-loading');

      this.image.addEventListener(
        'transitionend',
        () => {
          this.image.src = newImage.src;
          this.image.srcset = newImage.srcset;
          this.image.onload = () => {
            this.media.classList.remove('is-loading');
            this.media.classList.add('is-loaded');
          };
        },
        { once: true },
      );
    }

    getImage(variantId) {
      return this.variantsImages.filter(
        (variant) => variant.id === variantId,
      )[0].image;
    }
  }

  customElements.define('card-product', CardProduct);
}
